export enum ReoccurrenceNth {
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
  Last = 'Last',
  Every = 'every',
}
